import { render, staticRenderFns } from "./Uso.vue?vue&type=template&id=9d105c3c&scoped=true&"
import script from "./Uso.vue?vue&type=script&lang=js&"
export * from "./Uso.vue?vue&type=script&lang=js&"
import style0 from "./Uso.vue?vue&type=style&index=0&id=9d105c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d105c3c",
  null
  
)

export default component.exports